module.exports = __webpack_public_path__ + "img/学术会议-2.69977798.png";